import "./src/styles/global.css";
import "firebase/analytics";
import firebase from "gatsby-plugin-firebase";

require("prismjs/themes/prism-solarizedlight.css");

export const onClientEntry = () => {
  firebase.analytics();
};
